/*
* https://davidwalsh.name/javascript-debounce-function
*/

var sp;
if (!sp) {
    sp = {};
}

$.extend(sp,
    /**
     * @lends streamplus
     */
    {
        /**
         * @type {function}
         * @description debounce function for scroll & resize
         */
        debounce: function(func, wait, immediate){
            var timeout;
            return function() {
                var context = this, args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }
    }
);
